import { PaginationParams } from 'components/general/models/pagination-params'
import { RootState } from 'redux/store'
import { PrebuiltOptionEntity } from 'redux/types/prebuiltOptions.type'
import { preBuiltOptionsApi } from 'services/prebuiltOptions.service'

export const selectAllOptionsByDefaultQuery = (state: RootState, query: PaginationParams<PrebuiltOptionEntity, {}>) =>
    preBuiltOptionsApi.endpoints.getPrebuiltOptions.select(query)(state)
